const getApiUrl = (endpoint = "") =>
  (process.env.REACT_APP_API_URL || "") + endpoint;

export default getApiUrl;
